import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelfUser, getShops } from "../../../../../services/auth/actions";
import { useHistory } from "react-router";
import { Button } from "components";
import Paylix from "assets/images/sellix_logo.svg";
import PaylixEcommerceWhite from "assets/images/sellix_logo_white.svg";
import { completeSetup } from "../../../screens/setup/actions";
import useTheme from "../../../../../hooks/useTheme";

import "./style.scss";


const Header = ({ step, setStep }) => {

	const dispatch = useDispatch();
	const history = useHistory();
	const isDark = useTheme();
	const isAuth = useSelector(({ auth }) => auth.isAuth);

	const skipSetup = () => {
		dispatch(completeSetup())
			.then(() => {
				dispatch(getSelfUser())
					.then(() => history.push({
						pathname: "/"
					}))
			})
	}

	useEffect(() => {

		if(!isAuth) {
			dispatch(getSelfUser())
				.then(({ status, data }) => {
					if (status === 200) {
						dispatch(getShops(data.user.username));
					}
				})
		}

	}, []);

	const CheckIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 10.1667L8 14.3333L16 6" stroke="#239F51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>


	return <>
		<div className="setup-header-container">
			<div className="setup-header">

				<div className="setup-header-logo">
					<div className="setup-header-logo-image">
						<img src={isDark ? PaylixEcommerceWhite : Paylix} width="70" height="20" alt="paylixecommerce" className="setup-header-logo-image-big" />
					</div>
				</div>

				<div className="setup-header-line">
					<div onClick={() => setStep(0)}><span className={`${step === 0 ? "active" : ""} ${step > 0 ? "checked" : ""}`}>{step > 0 ? <CheckIcon /> : "1"}</span> General</div>
					<div onClick={() => setStep(1)}><span className={`${step === 1 ? "active" : ""} ${step > 1 ? "checked" : ""}`}>{step > 1 ? <CheckIcon /> : "2"}</span> Notification</div>
					<div onClick={() => setStep(2)}><span className={`${step === 2 ? "active" : ""} ${step > 2 ? "checked" : ""}`}>{step > 2 ? <CheckIcon /> : "3"}</span> Crypto</div>
					<div onClick={() => setStep(3)}><span className={`${step === 3 ? "active" : ""} ${step > 3 ? "checked" : ""}`}>{step > 3 ? <CheckIcon /> : "4"}</span> Terms</div>
					<div onClick={() => setStep(4)}><span className={`${step === 4 ? "active" : ""} ${step > 4 ? "checked" : ""}`}>{step > 4 ? <CheckIcon /> : "5"}</span> Personal</div>
				</div>

				<div className="setup-header-nav">
					<Button variant="secondary" size="large" className="text-nowrap" onClick={skipSetup}>Skip Setup</Button>
				</div>

			</div>

			<div className="setup-header-container-mobile">
				<div onClick={() => setStep(0)}><span className={`${step === 0 ? "active" : ""} ${step > 0 ? "checked" : ""}`}>{step > 0 ? <CheckIcon /> : "1"}</span> </div>
				<div onClick={() => setStep(1)}><span className={`${step === 1 ? "active" : ""} ${step > 1 ? "checked" : ""}`}>{step > 1 ? <CheckIcon /> : "2"}</span> </div>
				<div onClick={() => setStep(2)}><span className={`${step === 2 ? "active" : ""} ${step > 2 ? "checked" : ""}`}>{step > 2 ? <CheckIcon /> : "3"}</span> </div>
				<div onClick={() => setStep(3)}><span className={`${step === 3 ? "active" : ""} ${step > 3 ? "checked" : ""}`}>{step > 3 ? <CheckIcon /> : "4"}</span> </div>
				<div onClick={() => setStep(4)}><span className={`${step === 4 ? "active" : ""} ${step > 4 ? "checked" : ""}`}>{step > 4 ? <CheckIcon /> : "5"}</span> </div>
			</div>
		</div>
	</>
}


export default Header;
